import { SxProps } from '@mui/material';

export const cardTitleSX: SxProps = {
	color: 'grey.500',
};
